import { useRequest } from 'ahooks'

import { asyncSuccessResolver } from '$app/utilities'
import useSignal from '$actions/useSignal'

import api from '$model/api'
import { successResolver } from '$services/api/common'

export const useGetPasskeys = () => {
  const { mfaAuth: apiInstance } = useSignal(api)
  const { mfaPasskeys } = apiInstance

  const {
    data,
    loading,
    error,
    refreshAsync: refresh
  } = useRequest(asyncSuccessResolver(mfaPasskeys, successResolver))

  const { passkeys = [] } = data?.data ?? {}

  const hasError = !!error === true
  const isEmpty = passkeys.length === 0 || hasError

  return {
    loading,
    hasError,
    isEmpty,
    passkeys,
    refresh
  }
}
